import React, { useCallback } from "react";
import { colors } from "@ui/style/colors";
import Cross from "@assets/icons/cross.svg";
import styled from "@emotion/styled";
import { row } from "@ui/style/layout";
import { Filter } from "@domain/filters/filter";

export enum FilterItemStatus {
	Inactive,
	Active,
	Tag,
}

export interface FilterItemProps {
	status: FilterItemStatus;
	filter: Filter;
	onChange: (isActive: boolean) => void;
}

export const FilterItem: React.FC<FilterItemProps> = ({ status, filter, onChange }) => {
	const handleOnClick = useCallback(() => {
		onChange(status === FilterItemStatus.Inactive);
	}, [onChange, status]);

	return (
		<FilterItemContainer status={status} onClick={status === FilterItemStatus.Tag ? undefined : handleOnClick}>
			{filter.icon && <div>{filter.icon}</div>}
			<div>{filter.label}</div>
			{status === FilterItemStatus.Tag && (
				<CrossContainer onClick={handleOnClick}>
					<StyledCross />
				</CrossContainer>
			)}
		</FilterItemContainer>
	);
};

const FilterItemContainer = styled.div<{ status: FilterItemStatus }>`
	${row(2, undefined, "center")}

	min-height: 36px;
	padding: 0 ${({ status }) => (status === FilterItemStatus.Tag ? "5px" : "12px")} 0 12px;
	cursor: ${({ status }) => (status === FilterItemStatus.Tag ? "default" : "pointer")};
	white-space: nowrap;
	width: fit-content;
	border-radius: 8px;
	background-color: ${({ status }) => (status === FilterItemStatus.Inactive ? "transparent" : colors.primary10)};
	border: 1px solid ${({ status }) => (status === FilterItemStatus.Inactive ? colors.primary25 : colors.primary)};
	color: ${({ status }) => (status === FilterItemStatus.Inactive ? colors.grey : colors.black)};

	:hover {
		background-color: ${({ status }) =>
		status === FilterItemStatus.Inactive ? colors.primaryBackground : colors.primary25};
	}
`;

const CrossContainer = styled.div`
	cursor: pointer;
	display: flex;
	padding: 5px 5px;
`;

const StyledCross = styled(Cross)`
	color: ${colors.grey80};
	width: 20px;
	height: 20px;
`;
